module.exports = __webpack_public_path__ + "static/media/icons for website-02.5b4e1f88.svg";